import getEnvConfig from "./config";

export const isLmsHost = () => getEnvConfig().elti_config != null;

 export const redirectToLms = () => {
   const redirectUrl = getEnvConfig().elti_config?.redirect_url;
   if (!redirectUrl) {
     throw Error("Redirect url not found.")
   }
   window.location.replace(redirectUrl);
 };